import morph from "../helpers/morph";

class MainCart extends HTMLElement {
  constructor() {
    super();
    this.requestId = 1;
    this.closeButton = this.querySelector("[data-close]");
    this.wrapper = this.closest(".main-cart__wrapper");
    this.cartToggle = this.querySelector("[data-cart-toggle]");
    this.form = this.querySelector("form");
    this.sectionId = this.dataset.mainCartSectionId;

    this.cartToggle?.addEventListener("click", () => {
      this._toggleCart();
    });

    this.addEventListener("click", (e) => {
      const removeButton = e.target.closest("[data-remove]");
      const cartItem = e.target.closest(".cart-item");

      if (!removeButton) return;
      cartItem.classList.add("removing");
      this._updateQty({ key: removeButton.dataset.remove, quantity: 0 });
    });

    document.addEventListener("updateCart", (e) => {
      const requestId = e.detail.data?.requestId;

      // Debounce - cancel update if another request is already in progress.
      if (requestId === this.requestId || !requestId) {
        this._updateCart(e.detail.cart.sections[this.sectionId]);
      }
    });

    this.addEventListener("change", (e) => {
      const item = e.target.closest("[data-item-key]");
      if (!item) return;

      this._updateQty({
        key: item.dataset.itemKey,
        quantity: parseInt(e.target.value, 10),
      });
    });

    if (new URL(window.location).searchParams.has("cart")) {
      this._open();
    }

    this._getShippingRates();
  }

  _updateQty({ key, quantity }) {
    window.changeCart(
      { id: key, quantity },
      {
        onError: () => this._refreshCart(),
        data: { requestId: ++this.requestId },
      },
    );
  }

  _toggleCart() {
    this.cartToggle.classList.toggle("hiding");
    this.form.classList.toggle("main-cart__form--hide");
  }

  _getShippingRates() {
    this.shippingInfo = this.querySelector("[data-shipping]")
      ? this.querySelector("[data-shipping]")
      : null;

    if (!this.shippingInfo) return;

    this.shippingCountry = this.shippingInfo.dataset.shippingCountry;
    this.shippingProvince = this.shippingInfo.dataset.shippingProvince;
    this.shippingZip = this.shippingInfo.dataset.shippingZip;
    this.shippingPrice = this.querySelector("[data-shipping-price]");

    return window
      .fetch(
        `/cart/shipping_rates.json?shipping_address%5Bzip%5D=${this.shippingZip}&shipping_address%5Bcountry%5D=${this.shippingCountry}&shipping_address%5Bprovince%5D=${this.shippingProvince}`,
      )
      .then((response) => {
        return response.text();
      })
      .then((result) => {
        const parsedResult = JSON.parse(result);

        if (parsedResult) {
          this.shippingPrice.textContent = `${window.formatMoney(parsedResult.shipping_rates[0].price)}`;
        }
      });
  }

  _refreshCart() {
    window
      .fetchPageData({ path: "/", options: { sectionId: this.sectionId } })
      .then((markup) => this._updateCart(markup));
  }

  _updateCart(markup) {
    const html = new DOMParser().parseFromString(markup, "text/html");
    const sourceContent = html.querySelector(".main-cart__wrapper");

    morph(this.wrapper, sourceContent);
  }
}

if (!customElements.get("main-cart")) {
  customElements.define("main-cart", MainCart);
}
